import * as actionsType from './actionsType';
import axiosInstance from '../../axiosInstance';

export const bookStart = () => {
    return {
        type: actionsType.BOOK_START,
    };
};

export const bookSuccess = () => {
    return {
        type: actionsType.BOOK_SUCCESS,
    };
};

export const bookFail = (error) => {
    return {
        type: actionsType.BOOK_FAIL,
        error: error,
    };
};

export const book = (data) => {
    return dispatch => {
        dispatch(bookStart());
        axiosInstance.post(
            '/book-trip.php',
            data,
            { headers: { 'Content-Type': 'application/json' } }
        )
            .then(response => {

                const responseData = response.data;
                if (responseData.success) {
                    dispatch(bookSuccess());
                } else {
                    let errors = ['Server error'];
                    if (responseData.errors) {
                        errors = responseData.errors;
                    }
                    dispatch(bookFail(errors));
                }
            })
            .catch(error => {
                console.log(error);
                dispatch(bookFail(error.message));
            });
    };
}